import Footer from '../footer/Footer';

const FooterBlock = ({ footerContent: content }) => {
  return content ? <Footer footer={content} /> : null;
};
export default FooterBlock;
